"use client";

// Extend the Window interface to include dataLayer
declare global {
  interface Window {
    dataLayer: any[];
  }
}

import SalifyFallback from "src/lib/components/salify-fallback/default";

import ProductDetailsPageView from "./default/product-details";
import { Product } from "src/lib/fetcher/client";
import { useEffect, useMemo } from "react";

// ==============================================================
const ProductDetails = () => {
  const product: Product = SalifyFallback.useSelect("output:product.data");
  const relatedProducts: Product[] = SalifyFallback.useSelect("output:relatedProducts.data");
  const structuredData = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "Product",
      name: product.name,
      description: product.description,
      sku: product.code,
      image: product.imageUrl,
      offers: {
        "@type": "Offer",
        priceCurrency: "VND",
        price: product.salePrice,
      },
      brand: {
        name: product.brand?.name,
      },
    }),
    [product],
  );

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(structuredData);
  }, [structuredData]);

  return (
    <>
      <ProductDetailsPageView
        product={product}
        frequentlyBought={[]}
        relatedProducts={relatedProducts}
      />
    </>
  );
};

export default ProductDetails;
